/**
 * Debug utility for development-only logging
 * Only shows logs in development environment
 */

interface DebugLogger {
  log: (...args: any[]) => void;
  error: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  info: (...args: any[]) => void;
}

const isDevelopment = import.meta.env.DEV || process.env.NODE_ENV === 'development';

export const debug: DebugLogger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  }
};

// For production errors that should always be logged
export const logger = {
  error: console.error,
  warn: console.warn,
};
